<template>
  <div class="container" :class="{vertical: isVertical, bottomFix: isBottomFix}" :style="{'color':color}">
    <div class="leftArrow arrow" v-if="arrowWidth > 0"></div>
    <div class="middle" v-if="arrowWidth > 0" :style="{'width': arrowWidth + 'px','background-color':color}"></div>
    <div class="rightArrow arrow" v-if="itemWidth > 0" :style="{'left': arrowWidth + 'px'}"></div>
  </div>
</template>
<script>
export default {
  name: 'USTArrrow',
  props: ['isVertical', 'isBottomFix', 'itemWidth', 'color'],
  data () {
    return {
      arrowOffset: 14
    }
  },
  computed: {
    arrowWidth () {
      return this.isVertical ? this.itemWidth - this.arrowOffset : this.itemWidth
    }
  }
}
</script>
<style scoped>
.container {
  position: relative;
}
.vertical {
  transform: rotate(90deg);
  transform-origin: left top;
  -ms-transform: rotate(90deg); /* Internet Explorer */
  -moz-transform: rotate(90deg); /* Firefox */
  -webkit-transform: rotate(90deg); /* Safari 和 Chrome */
  -o-transform: rotate(90deg);
}
.bottomFix {
  transform: rotate(-90deg);
  transform-origin: left top;
  -ms-transform: rotate(-90deg); /* Internet Explorer */
  -moz-transform: rotate(-90deg); /* Firefox */
  -webkit-transform: rotate(-90deg); /* Safari 和 Chrome */
  -o-transform: rotate(-90deg);
}
.arrow {
  position: relative;
}
.leftArrow {
  left: -12px;
  bottom: -7px;
  width: 0;
  height: 0;
  border-width: 6px;
  border-style: solid;
  border-color:transparent;
  border-right-color: inherit;
}
.rightArrow {
  bottom: 7px;
  width: 0;
  height: 0;
  border-width: 6px;
  border-style: solid;
  border-color:transparent;
  border-left-color: inherit;
}
.middle {
  height: 2px;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/view/graph/UST/USTArrow.vue